<!--
 * @Author: Haoxiwei 1078734933@qq.com
 * @Date: 2023-07-27 09:24:27
 * @LastEditors: Haoxiwei 1078734933@qq.com
 * @LastEditTime: 2024-10-31 12:28:04
 * @FilePath: /wemeet-admin-new/src/views/aiProduct/venueManage.vue
 * @Description: 
 * Copyright (c) 2023 by WeMeet, All Rights Reserved. 
-->
<template>
  <div>
    <vab-query-form>
      <vab-query-form-left-panel :span="12">
        <el-button type="primary" @click="addVenue($event)">添加场地</el-button>
      </vab-query-form-left-panel>
      <vab-query-form-right-panel :span="12">
        <el-form :inline="true" :model="queryForm" @submit.prevent>
          <el-form-item label="场地名称">
            <el-input v-model="queryForm.name" placeholder="请输入场地名称" type="text" />
          </el-form-item>
          <el-form-item label="状态">
            <el-select v-model="queryForm.status">
              <el-option v-for="item in statusList" :key="item.key" :label="item.label" :value="item.key" />
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="queryData($event)">查询</el-button>
          </el-form-item>
        </el-form>
      </vab-query-form-right-panel>
    </vab-query-form>
    <el-table v-loading="listLoading" border :data="list">
      <el-table-column label="序号" type="index" width="120" />
      <el-table-column label="场地名称" prop="venueName" show-overflow-tooltip />
      <el-table-column label="状态" prop="status" show-overflow-tooltip>
        <template #default="{ row }">
          <el-tag v-if="row.status == 'NOT_USE'" type="danger">未使用</el-tag>
          <el-tag v-else type="success">已使用</el-tag>
        </template>
      </el-table-column>

      <el-table-column label="操作" show-overflow-tooltip width="420">
        <template #default="{ row }">
          <el-button plain type="info" @click="handleEdit(row)">编辑</el-button>
          <el-button plain type="info" @click="handleAddManage(row)">设置管理员</el-button>
          <el-button plain type="info" @click="seeHistory(row)">查看预定日志</el-button>
          <el-button plain type="danger" @click="handleDel(row)">删除</el-button>
        </template>
      </el-table-column>
      <template #empty>
        <!-- <el-image
          class="vab-data-empty"
          :src="require('@/assets/empty_images/data_empty.png')"
        /> -->
        <el-empty class="vab-data-empty" description="暂无数据" />
      </template>
    </el-table>
    <!-- <el-pagination background :current-page="queryForm.pageNum" :layout="layout" :page-size="queryForm.pageSize" :total="total" @current-change="handleCurrentChange" @size-change="handleSizeChange" /> -->
    <editVenue ref="editVenueRef" :meeting-code="meetingCode" @fetchData="fetchData" />

    <venueAddUser ref="venueAddUserRef" />

    <queryHistory ref="queryHistoryRef" />
  </div>
</template>

<script>
  import {
    defineComponent,
    defineAsyncComponent,
    getCurrentInstance,
    onMounted,
    reactive,
    toRefs,
    onActivated,
  } from 'vue'

  import { Delete, Plus, Search } from '@element-plus/icons'
  import {
    getVenueList,
    venueDel,
    // abstractCloseOrOpen,
    // getAbstractLink,
    // batchOpenAbstract,
    // batchCloseAbstract,
  } from '@/api/ai'
  import { useRoute } from 'vue-router'
  import editVenue from './components/editVenue.vue'
  import venueAddUser from '@/components/venueAddUser.vue'
  import queryHistory from './components/queryHistory.vue'
  import generateWx from '@/components/generateWx/generateWx.vue'
  import { parseTime } from '@/utils/index'
  import { baseH5URL } from '@/config'
  import Clipboard from 'clipboard'
  export default defineComponent({
    name: 'Brand',
    components: { editVenue, venueAddUser, queryHistory, generateWx },
    setup() {
      const { proxy } = getCurrentInstance()
      const route = useRoute()
      const state = reactive({
        queryForm: {
          name: '',
          status: '',
        },
        isShow: true,
        total: 0,
        listLoading: false,
        list: [],
        layout: 'total, sizes, prev, pager, next, jumper',
        editRef: null,
        previewDialog: null,
        previewQrcode: '',
        previewWebSite: '',
        enterpriseCode: '',
        editVenueRef: null,
        queryHistoryRef: null,
        tabName: 'product',
        meetingType: '',
        meetingCode: '',
        statusList: [
          {
            key: '',
            label: '全部',
          },
          {
            key: 'NOT_USE',
            label: '未使用',
          },
          {
            key: 'USE',
            label: '已使用',
          },
        ],
        upLoadRef: null,
        resultRef: null,
        chooseVal: [],
        industryType: '',
        editAbstractRef: null,
        addManageUserRef: null,
        venueAddUserRef: null,
        linkUrl: '',
      })

      /**
       * @description: 编辑展商
       * @param {*} row
       * @return {*}
       */
      const handleEdit = (row) => {
        state.editVenueRef.handleOpen(row)
      }

      const handleAddManage = (row) => {
        console.log('123123123', state.venueAddUserRef, state.editVenueRef)
        state.venueAddUserRef.handleOpen(row)
      }

      const handleAbstract = (row) => {
        state.editAbstractRef.handleOpen(row)
      }

      const handleIdea = (row) => {
        state.editIdeaRef.handleOpen(row)
      }

      const fetchData = async () => {
        state.meetingCode = route.query.meetingCode
        state.listLoading = true
        const { data } = await getVenueList(state.queryForm)
        state.list = data
        state.listLoading = false
      }

      const handleSizeChange = (val) => {
        state.queryForm.pageSize = val
        fetchData()
      }
      const handleCurrentChange = (val) => {
        state.queryForm.pageNum = val
        fetchData()
      }

      const queryData = (val) => {
        fetchData()
      }

      const handleDate = (val) => {
        return parseTime(val)
      }
      const productStatusChange = async (row) => {
        try {
          let obj = {
            isOpen: row.isOpenAiAbstractSentence,
            sentenceId: row.status,
          }
          await editBrandProductStatus(obj)
          proxy.$baseMessage(`操作成功`, 'success', 'vab-hey-message-success')
        } catch (e) {
          proxy.$baseMessage(`操作失败`, 'error', 'vab-hey-message-error')
        }
      }

      const abstractCloseOrOpenFunc = async () => {
        try {
          let obj = {
            isOpen: state.isShow,
            meetingCode: state.meetingCode,
          }
          await abstractCloseOrOpen(obj)
          proxy.$baseMessage(`操作成功`, 'success', 'vab-hey-message-success')
        } catch (e) {
          proxy.$baseMessage(`操作失败`, 'error', 'vab-hey-message-error')
        }
      }

      onMounted(() => {
        fetchData()
      })

      const handleSelectionChange = (val) => {
        state.chooseVal = val
      }

      const batchStatus = async (status) => {
        console.log(state.chooseVal)
        let params = {
          params: state.chooseVal.map((v) => v.scheduleCode),
        }
        if (status == 'open') {
          await batchOpenAbstract(params)
        } else {
          await batchCloseAbstract(params)
        }

        fetchData()
      }

      const addVenue = async () => {
        state.editVenueRef.handleOpen()
      }

      const handleDel = async (row) => {
        row.meetingType = 'EXHIBITION'
        row.meetingCode = state.meetingCode
        proxy.$baseConfirm('你确定要删除当前项吗', null, async () => {
          await venueDel(row)
          proxy.$baseMessage(`操作成功`, 'success', 'vab-hey-message-success')
          await fetchData()
        })
      }

      const seeHistory = (row) => {
        state.queryHistoryRef.handleOpen(row)
      }

      return {
        ...toRefs(state),
        handleEdit,
        fetchData,
        handleSizeChange,
        handleCurrentChange,
        productStatusChange,
        Delete,
        Search,
        Plus,
        handleSelectionChange,
        batchStatus,
        handleDate,
        handleAbstract,
        handleIdea,
        abstractCloseOrOpenFunc,
        addVenue,
        handleAddManage,
        handleDel,
        queryData,
        seeHistory,
      }
    },
  })
</script>
<style lang="scss" scoped></style>
